import { z } from "zod";

import { triggerConditionBuildSchema } from "../shared/triggers.ts";
import { conditionsStateSchema } from "./conditionDesignsStateSchema.ts";
import { effectDesignsStateSchema } from "./effectDesignsStateSchema.ts";

const responseDetailsSchema = z.object({
  id: z.number().int(),
  label: z.string().optional(),
});

export type ResponseDetails = z.infer<typeof responseDetailsSchema>;

export const responsePropertiesSchema = responseDetailsSchema.omit({ id: true });

export type ResponseProperties = z.infer<typeof responsePropertiesSchema>;

const responsesByIdStateSchema = z.record(responsePropertiesSchema);

export type ResponsesByIdState = z.infer<typeof responsesByIdStateSchema>;

export const triggerCaseSchema = z.object({
  eventType: z.string(),
  where: triggerConditionBuildSchema.optional(),
});

export type TriggerCase = z.infer<typeof triggerCaseSchema>;

export const handlerCaseSchema = z.object({
  eventType: z.string(),
  where: triggerConditionBuildSchema.optional(),
});

export type HandlerCase = z.infer<typeof handlerCaseSchema>;

const handlerDetailsSchema = z.object({
  id: z.number().int(),
  label: z.string().optional(),
  cases: z.array(handlerCaseSchema).optional(),
});

export type HandlerDetails = z.infer<typeof handlerDetailsSchema>;

export const handlerPropertiesSchema = handlerDetailsSchema.omit({ id: true });

export type HandlerProperties = z.infer<typeof handlerPropertiesSchema>;

const handlersByIdStateSchema = z.record(handlerPropertiesSchema);

export type HandlersByIdState = z.infer<typeof handlersByIdStateSchema>;

const triggerDetailsSchema = z.object({
  id: z.number().int(),
  label: z.string().optional(),
  cases: z.array(triggerCaseSchema),
});

export type TriggerDetails = z.infer<typeof triggerDetailsSchema>;

export const triggerPropertiesSchema = triggerDetailsSchema.omit({ id: true });

export type TriggerProperties = z.infer<typeof triggerPropertiesSchema>;

const triggersByIdStateSchema = z.record(triggerPropertiesSchema);

export type TriggersByIdState = z.infer<typeof triggersByIdStateSchema>;

const idsStateSchema = z.object({
  triggerIdsByNodeId: z.record(z.array(z.number().int())),
  handlerIdsByTriggerId: z.record(z.array(z.number().int())),
  responseIdsByHandlerId: z.record(z.array(z.number().int())),
  triggerIdByHandlerId: z.record(z.number().int()),
  handlerIdByResponseId: z.record(z.number().int()),
  nodeIdByTriggerId: z.record(z.number().int()),
});

export type IdsState = z.infer<typeof idsStateSchema>;

export const triggerDesignsStateSchema = z.object({
  triggersById: triggersByIdStateSchema,
  handlersById: handlersByIdStateSchema,
  responsesById: responsesByIdStateSchema,
  effects: effectDesignsStateSchema,
  conditions: conditionsStateSchema,
  ids: idsStateSchema,
});

export type TriggerDesignsState = z.infer<typeof triggerDesignsStateSchema>;
